import React from 'react';
import { Helmet } from 'react-helmet-async';

// Single source of truth for every page's title, description, canonical URL,
// Open Graph, and Twitter Card tags, plus optional JSON-LD. Centralizing
// this here means every route gets the full, correct tag set automatically
// instead of each page remembering to repeat the same boilerplate (and
// forgetting one, the way the old single static index.html could never
// actually vary per section at all).
//
// bikesdrop.com is the real production domain (custom domain already
// connected to this Firebase Hosting site). The old bikesdrop-landing.web.app
// referenced throughout the previous static tags does not exist, every
// canonical/OG/sitemap URL pointing at it was a dead link.
export const SITE_URL = 'https://bikesdrop.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/og-image.jpg`;
export const SITE_NAME = 'BikesDrop';

export default function SEO({ title, description, path = '/', image = DEFAULT_OG_IMAGE, imageAlt, noindex, jsonLd }) {
  const url = `${SITE_URL}${path}`;
  const jsonLdList = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_GH" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

      {jsonLdList.map((entry, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
}
